import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=5489a83f&scoped=true&"
import script from "./DateFilter.vue?vue&type=script&lang=ts&"
export * from "./DateFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DateFilter.vue?vue&type=style&index=0&id=5489a83f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489a83f",
  null
  
)

export default component.exports